import React from 'react'
import { useCancellations } from './hooks'
import { CancellationsMobileRows } from './components'
import { TableV2 } from '~/components/v2/TableV2'
import { TableToolBar, TableFallback } from '~/components/v2/TableV2/components'
import { PageWrapper, Container, HeaderContainer, Header, TableWrapper } from './styles'

export const Cancellations = () => {
  const {
    isMobile,
    drawerWidth,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    pageIndex,
    pageSize,
    pageCount,
    pageOptions,
    canNextPage,
    canPreviousPage,
    setPageSize,
    totalCount,
    prepareRow,
    visibleColumns,
  } = useCancellations()

  return (
    <>
      <PageWrapper isMobile={isMobile} drawerWidth={drawerWidth}>
        <Container>
          <HeaderContainer>
            <Header>Pedidos de cancelamento</Header>
            {!isMobile && !!page.length && (
              <TableToolBar
                paginationComponent={true}
                pageSizeComponent={true}
                page={page}
                previousPage={previousPage}
                nextPage={nextPage}
                pageCount={pageCount}
                pageIndex={pageIndex}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageOptions={pageOptions}
                canNextPage={canNextPage}
                canPreviousPage={canPreviousPage}
                totalCount={totalCount}
              />
            )}
          </HeaderContainer>

          <TableWrapper>
            {page.length ? (
              <TableV2
                testID="cancellation-table"
                getTableProps={getTableProps}
                getTableBodyProps={getTableBodyProps}
                headerGroups={headerGroups}
                page={page}
                prepareRow={prepareRow}
                isMobile={isMobile}
                visibleColumns={visibleColumns}
                SubComponent={CancellationsMobileRows}
                previousPage={previousPage}
                nextPage={nextPage}
                pageCount={pageCount}
                pageIndex={pageIndex}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageOptions={pageOptions}
                canNextPage={canNextPage}
                canPreviousPage={canPreviousPage}
                totalCount={totalCount}
              />
            ) : (
              <TableFallback text={'Você ainda não possui cancelamentos'} />
            )}
          </TableWrapper>
        </Container>
      </PageWrapper>
    </>
  )
}
